import getCert from './get-cert';
import Image from 'core/image';
import styles from 'styles/Footer.module.scss';

const CertFooter = () => {
    const certs = getCert();
    return (
        <div className={styles.certContainer}>
            {
                certs && (
                    certs.map((cert) => (
                        <a target="_blank" href={cert.link} key={cert.alt} rel="noreferrer">
                            <Image
                                alt={cert.alt}
                                src={cert.img}
                                width={cert.width}
                                height={cert.height}
                                quality={90} />
                        </a>
                    ))
                )
            }
        </div>
    );
};

export default CertFooter;
